export default __webpack_public_path__ + "static/media/green-key.d274ece4.svg";